import { createSelector } from '@ngxs/store';
import { TreeEntityType } from 'commons';
import type { TreeStateModel } from './tree.model';

/**
 * Lightweight, standalone version of `TreeState.getRoots` that does not import
 * the `TreeState` class itself, so consumers (e.g. `SettingsState`, which is a
 * root-level eager state) don't transitively pull in the tree state's full
 * dependency graph (Dexie, `MultiViewState`, ECharts, ...) into the main bundle.
 */
const treeStateSlice = (state: { tree_state: TreeStateModel }) => state.tree_state;

export const getTreeRoots = createSelector(
  [treeStateSlice],
  (state: TreeStateModel) => state?.flatTree?.filter(({ type }) => type === TreeEntityType.USE_CASE_ROOT) ?? []
);
